import { getOrCreateAuthStore } from './authStore';

// eslint-disable-next-line @typescript-eslint/no-extraneous-class -- Legacy code
export class NavinaCache {
	static genKey = (key: string) => {
		const sub = getOrCreateAuthStore().jwtData?.sub;
		if (sub) {
			return `${sub}_${key}`;
		}
	};

	static remove = (key: string): void => {
		if (this.exist(key)) {
			// @ts-expect-error - Legacy code, nullability not yet enforced
			localStorage.removeItem(this.genKey(key));
		}
	};

	static get = (key: string): string | undefined => {
		if (this.exist(key)) {
			// @ts-expect-error - Legacy code, nullability not yet enforced
			return localStorage.getItem(this.genKey(key));
		}

		return undefined;
	};

	static getArray = (key: string): string[] => {
		if (this.exist(key)) {
			// @ts-expect-error - Legacy code, nullability not yet enforced
			return localStorage.getItem(this.genKey(key)).split(',');
		}

		return [];
	};

	static set = (key: string, value: any): void => {
		if (!value || value.length === 0) {
			// @ts-expect-error - Legacy code, nullability not yet enforced
			localStorage.removeItem(this.genKey(key));
		} else {
			// @ts-expect-error - Legacy code, nullability not yet enforced
			localStorage.setItem(this.genKey(key), value);
		}
	};

	static exist = (key: string): boolean => {
		// @ts-expect-error - Legacy code, nullability not yet enforced
		return Boolean(localStorage.getItem(this.genKey(key)));
	};

	static getAllStorageMatchingKeys = (keyPrefix: string): string[] => {
		const keys = Object.keys(localStorage);
		const keysWithoutSubPart = keys.map((k) => k.split('_').splice(1).join('_'));
		return keysWithoutSubPart.filter((k): boolean => k.startsWith(keyPrefix));
	};
}
